// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"94e1ce46","110":"9c64b050","160":"2bb40725","165":"0d8398bf","222":"47d3ffcc","322":"bf089969","344":"c9e9e061","584":"15a649cb","624":"320bf719","685":"7ab97838","712":"81b13a25","922":"5af69a50"}[chunkId] + ".chunk.js";
};